import EmployeeItem from "./EmployeeItem"

const EmployeeList = ({ employees }) => {
    return (
        <table className="table">
        <thead className="thead-dark">
            <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Action</th>
            </tr>
        </thead>
        <tbody>
            {employees.filter(i =>i.ID !== 1).map(i=> {
                return <EmployeeItem key={i.ID} employee={i} />
            })}
        </tbody>
    </table>
    )
}

export default EmployeeList